// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"60":"c0fa6ee595f20406","144":"e1e848cba1867981","408":"db39d74ef1b86a67"}[chunkId] + ".js";
};